import request from '@/utils/request'

// 获取成本构成配置列表
export function getAllCostCompose() {
  return request({
    url: '/api/srm-slcm/pmCostComposeConfig/all',
    method: 'get'
  })
}
